module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/particular01-d826de9e65e82d720a0c635aca4d3266.png";